import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailPageLayout, { DetailSection } from '../utils/DetailPageLayout';
import Segment from '../utils/segments';
import GroupReference from '../utils/groupReference';

function SingleMissionsContent(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const url = `${process.env.REACT_APP_API_BASE_URL}/api/missions/${id}`;

  useEffect(() => {
    setIsLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => setHasError(err))
      .finally(() => setIsLoading(false));
  }, [url]);

  if (isLoading) {
    return (
      <>
        <div className="detail-page">
          <p>Loading...</p>
        </div>
      </>
    );
  }

  if (hasError || !data) {
    return (
      <>
        <div className="detail-page">
          <p>Could not load this mission.</p>
        </div>
      </>
    );
  }

  const meta = [];
  if (data.Date) meta.push({ label: 'Date', value: data.Date });
  if (data.Country) meta.push({ label: 'Country', value: data.Country });
  if (data.SourceSite) meta.push({ label: 'Source', value: data.SourceSite });

  let refCounter = 0;

  return (
    <>
      <DetailPageLayout eyebrow="Mission" title={data.Name || 'Mission'} meta={meta}>
        {data.Description && (
          <DetailSection title="Operation">
            <p>{data.Description}</p>
          </DetailSection>
        )}

        {data.MdDescription && (
          <DetailSection title="Details">
            <div dangerouslySetInnerHTML={{ __html: data.MdDescription }} />
          </DetailSection>
        )}

        {data.Notes && (
          <DetailSection title="Notes">
            <p>{data.Notes}</p>
          </DetailSection>
        )}

        <DetailSection title="Segments">
          {data.Segments && data.Segments.length > 0
            ? data.Segments.map(seg => (
                <Segment key={seg.name} segment={seg} />
              ))
            : <p style={{ color: 'var(--color-ink-mute)', fontStyle: 'italic' }}>No segments recorded for this mission.</p>
          }
        </DetailSection>

        <DetailSection title="Group References">
          {data.GroupReferences && data.GroupReferences.length > 0
            ? data.GroupReferences.map(grRef => {
                refCounter++;
                return <GroupReference key={refCounter} grRef={grRef} />;
              })
            : <p style={{ color: 'var(--color-ink-mute)', fontStyle: 'italic' }}>No group references recorded for this mission.</p>
          }
        </DetailSection>
      </DetailPageLayout>
    </>
  );
}

export default SingleMissionsContent;
